(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ptw-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORE_KEY = 'ptw_nl_popup_v1';
    const SIGNUP_FLAG = 'ptw_nl_popup_signed_up';
    const SESSION_FLAG = 'ptw_nl_popup_session_shown';
    const SNOOZE_MS = 14 * 24 * 60 * 60 * 1000;

    function safeGet(storage, key) {
      try { return storage.getItem(key); } catch (e) { return null; }
    }
    function safeSet(storage, key, val) {
      try { storage.setItem(key, val); return true; } catch (e) { return false; }
    }

    function shouldSuppress() {
      const signed = safeGet(localStorage, SIGNUP_FLAG);
      if (signed === '1') return true;
      const closedAt = parseInt(safeGet(localStorage, STORE_KEY) || '0', 10);
      if (closedAt && (Date.now() - closedAt) < SNOOZE_MS) return true;
      let lsOk = false;
      try { localStorage.setItem('__ptw_t', '1'); localStorage.removeItem('__ptw_t'); lsOk = true; } catch (e) {}
      if (!lsOk && safeGet(sessionStorage, SESSION_FLAG) === '1') return true;
      return false;
    }

    class PtwNewsletterPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.ptw-nlp__dialog');
        this.closers = this.querySelectorAll('[data-ptw-close]');
        this.input = this.querySelector('.ptw-nlp__input');
        this.hasSuccess = !!this.querySelector('[data-ptw-success]');
        this.hasError = !!this.querySelector('[data-ptw-error]');

        this.closers.forEach(el => el.addEventListener('click', () => this.close()));
        this.onKey = this.onKey.bind(this);

        const form = this.querySelector('form');
        if (form) {
          form.addEventListener('submit', () => {
            // Only mark session-shown; the real success flag is set after the
            // server confirms (hasSuccess branch below), so a bounced submit
            // (invalid email, already-subscribed) doesn't suppress the popup forever.
            safeSet(sessionStorage, SESSION_FLAG, '1');
          });
        }

        if (this.hasSuccess) {
          safeSet(localStorage, SIGNUP_FLAG, '1');
          this.open();
          return;
        }
        if (this.hasError) {
          this.open();
          return;
        }

        if (shouldSuppress()) return;
        this.scheduleTriggers();
      }

      scheduleTriggers() {
        const mql = window.matchMedia('(min-width: 750px)');
        if (mql.matches) {
          this.scheduleDesktop();
        } else {
          this.scheduleMobile();
        }
      }

      scheduleDesktop() {
        const delay = (parseInt(this.dataset.desktopDelay, 10) || 12) * 1000;
        this.timer = setTimeout(() => this.open(), delay);
        this.exitHandler = (e) => {
          if (e.clientY <= 10) {
            this.open();
          }
        };
        document.documentElement.addEventListener('mouseleave', this.exitHandler);
      }

      scheduleMobile() {
        const delay = (parseInt(this.dataset.mobileDelay, 10) || 15) * 1000;
        this.timer = setTimeout(() => this.open(), delay);
        this.scrollHandler = () => {
          const h = document.documentElement.scrollHeight - window.innerHeight;
          if (h <= 0) return;
          if (window.scrollY / h >= 0.5) this.open();
        };
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
      }

      cancelTriggers() {
        if (this.timer) { clearTimeout(this.timer); this.timer = null; }
        if (this.exitHandler) {
          document.documentElement.removeEventListener('mouseleave', this.exitHandler);
          this.exitHandler = null;
        }
        if (this.scrollHandler) {
          window.removeEventListener('scroll', this.scrollHandler);
          this.scrollHandler = null;
        }
      }

      open() {
        if (this.hasAttribute('data-open')) return;
        this.cancelTriggers();
        this.previousFocus = document.activeElement;
        this.removeAttribute('hidden');
        this.setAttribute('aria-hidden', 'false');
        // Force a frame so the transition runs.
        requestAnimationFrame(() => {
          this.setAttribute('data-open', 'true');
        });
        document.addEventListener('keydown', this.onKey);
        safeSet(sessionStorage, SESSION_FLAG, '1');
        setTimeout(() => {
          const target = this.input && !this.hasSuccess ? this.input : this.dialog;
          if (target && typeof target.focus === 'function') target.focus();
        }, 60);
      }

      close() {
        if (!this.hasAttribute('data-open')) {
          // Still mark snooze if closed before open (edge case).
          safeSet(localStorage, STORE_KEY, String(Date.now()));
          return;
        }
        this.removeAttribute('data-open');
        this.setAttribute('aria-hidden', 'true');
        document.removeEventListener('keydown', this.onKey);
        if (!this.hasSuccess) {
          safeSet(localStorage, STORE_KEY, String(Date.now()));
        }
        const prev = this.previousFocus;
        setTimeout(() => {
          this.setAttribute('hidden', '');
          if (prev && typeof prev.focus === 'function') {
            try { prev.focus(); } catch (e) {}
          }
        }, 240);
      }

      onKey(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
          return;
        }
        if (e.key === 'Tab') {
          this.trapFocus(e);
        }
      }

      trapFocus(e) {
        const focusables = this.dialog.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (e.shiftKey) {
          if (active === first || !this.dialog.contains(active)) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (active === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    }

    if (!customElements.get('ptw-nl-popup')) {
      customElements.define('ptw-nl-popup', PtwNewsletterPopup);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
